import script from "./BillEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillEditor.vue?vue&type=script&setup=true&lang=ts"

import "./BillEditor.vue?vue&type=style&index=0&id=7131a1d1&lang=less"

const __exports__ = script;

export default __exports__